var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.995,
    height: 20.994,
    viewBox: "0 0 20.995 20.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#094674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05233a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-telegram",
    "data-name": "Icon awesome-telegram",
    d: "M10.5.563a10.5,10.5,0,1,0,10.5,10.5A10.5,10.5,0,0,0,10.5.563Zm5.156,7.191L13.93,15.872c-.127.576-.47.715-.948.444l-2.624-1.934L9.092,15.6a.662.662,0,0,1-.529.258l.186-2.671L13.613,8.8c.212-.186-.047-.292-.326-.106L7.276,12.473l-2.59-.808c-.563-.178-.576-.563.119-.834l10.121-3.9c.47-.169.88.114.728.825Z",
    transform: "translate(0 -0.563)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeTelegram);
export default __webpack_public_path__ + "static/media/Icon awesome-telegram.04bfd930794c3830959d19b5c20a9312.svg";
export { ForwardRef as ReactComponent };